@if (header()) {
  <h1 class="text-1">{{ header() }}</h1>
}

@if (subtitleTemplate()) {
  <ng-container *ngTemplateOutlet="subtitleTemplate()"></ng-container>
} @else if (subtitle()) {
  <p class="text-4">{{ subtitle() }}</p>
}

<ng-content />
